export const validateFile = (fileObjects: any, fileData?: any) => {
  const result = {
    isValid: false,
    message: "",
  };
  let fileArray = Object.values(fileObjects);
  const allowedExtensions =
    fileData?.allowedExtensions ||
    /(\.jpg|\.jpeg|\.png|\.gif|\.bmp|\.svg|\.doc|\.docx|\.pdf|\.txt|\.rtf|\.odt|\.md|\.csv|\.xls|\.xlsx|\.ppt|\.pptx)$/i;
  for (let i = 0; i < fileArray.length; i++) {
    const file: any = fileArray[i];
    if (!allowedExtensions.test(file.name)) {
      result.message = "Uploaded file is invalid";
      return result;
    }
  }
  result.isValid = true;
  return result;
};
